export default __webpack_public_path__ + "static/about_clearfuly-0fc29db357aadd8b0648f8e1e111a950.webp";